export default "__VITE_ASSET__DDPYzYlZ__"